(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name autoRosterSchedule.controller:AutoRosterScheduleCtrl
     *
     * @description
     *
     */
    angular
        .module('autoRosterSchedule')
        .directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	})
        .controller('AutoRosterScheduleCtrl', AutoRosterScheduleCtrl);

    function AutoRosterScheduleCtrl(applicationConstants, CommonMasterData, PopupManager,
                                    AutoRosterScheduleService, EventManagerService,MessageService, CommonLogicService, StorageServices, TabService, ConfigDistributionService) {
        var vm = this;
        vm.ctrlName = 'AutoRosterScheduleCtrl';
        vm.temp = null;
        vm.model = {
            isElasticLoadingVisible: false,
            showRightPanel:false,
            searchPanelToggle:true,
            searchCriteria:null,
            recordChange:false,
            masterList: {
                cycleList:[],
                crewTypes:[],
                airCraftTypes:[],
                crewBaseList:[],
                identifiers :[],
                statsList: [],
                crewList:[],
                mainCrewList:[],
                standByStrategiesList:[],
              fromDateAfterToDate: false,
              errorMessage:null,
            },
            autoScheduleList:[],
            initialSearchDone:false,
            selectedSchedule:null,
            selectedScheduleFromSubmit:null,
            editorMode: applicationConstants.EDITOR_STATUS.ADD
        };

      ConfigDistributionService.searchActiveIdentifiers(
                function(identifiers){
                    console.log(identifiers);
                    var identifierObject = [];
                    angular.forEach(identifiers ,function(identifier){
                       var updateExpiryCrewDTO = {
                            valueFieldName: identifier,
                            labelFieldName: identifier
                        };
                        identifierObject.push(updateExpiryCrewDTO);
                      });
                   vm.model.masterList.identifiers=identifierObject;
                   console.log(identifierObject);
                  },
                function(error){
                    MessageService.error(error);

                  }
              );

        EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

        vm.viewRosterStatusReportRadarChartModal = function (param) {
          var navigateToRosterStatusReportGrid = function(param) {
            var tabName = 'rosterStatusReportRadarChart';
            StorageServices.setTabData(tabName, 'rosterStatusReportRadarChartParams',
              param);
            TabService.gotoTab(tabName, {
              autoScheduleSetupId : param.autoScheduleSetupId
            });
          };
          navigateToRosterStatusReportGrid(param);
        }

        vm.clickOnSearch = function () {
            vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
            vm.model.initialSearchDone = false;
        };

        vm.onRefresh = function () {
        	vm.model.autoScheduleList = [];
            searchRosterSchedule();
        };

      vm.changeSearchCriteria = function (flag, searchCriteria) {
        if (flag === 'fromDate' && !CommonLogicService.compareDateTime(searchCriteria.fromDate, null, searchCriteria.toDate, null) && !vm.model.searchCriteria.toDate) {
          var tempFromDate = moment(vm.model.searchCriteria.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
          if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
            vm.model.searchCriteria.toDate = tempFromDate;
          }
        }
        if (vm.model.searchCriteria.fromDate && vm.model.searchCriteria.toDate) {
          if (!isDateFormatInvalid(vm.model.searchCriteria.fromDate) && !isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
            if (istoDateBeforeFromDate()) {
              vm.model.masterList.fromDateAfterToDate = true;
            } else {
              vm.model.masterList.fromDateAfterToDate = false;
            }
          }
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }

      };
      function isDateFormatInvalid(date) {
        if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
          return true;
        }
        return false;
      };

      function istoDateBeforeFromDate() {
        return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
          .isBefore(
            moment(vm.model.searchCriteria.fromDate,
              "DD/MM/YYYY"));
      };

        vm.doAction = function (selectedRowData, flag) {
            if (flag==='roster_status_report_radar_chart'){
              this.viewRosterStatusReportRadarChartModal(selectedRowData);
            }

            if (flag==='cancel'){
                selectedRowData.newStatus = vm.model.masterList.statsList.CANCELLED;
                AutoRosterScheduleService.setRosterAutoScheduleChangeStatusReq(selectedRowData);
            }
            if (flag==='stop'){
                selectedRowData.newStatus = vm.model.masterList.statsList.STOPPED;
                AutoRosterScheduleService.setRosterAutoScheduleChangeStatusReq(selectedRowData);
            }
            if (flag==='request'){
                selectedRowData.newStatus = vm.model.masterList.statsList.REQUESTED;
                AutoRosterScheduleService.setRosterAutoScheduleChangeStatusReq(selectedRowData);
            }
            if (flag==='delete'){
                deleteAutoRosterDistribution(selectedRowData.autoScheduleSetupId);
            }

            if(flag !== 'tooltip' && flag !== 'delete') {
              AutoRosterScheduleService.changeStatusRosterSchedule(
                function (response) {
                  if (response.success) {
                    MessageService.success('Status Changed!');
                    updateAutoRosterStatus(selectedRowData);
                  }
                },
                function (error) {
                  MessageService.error(error[0]);
                }
              );
            }else{
              moveOnError(selectedRowData);
            }
        };

      vm.changeAny = function (event, flag, operation, selectedItems) {
        return vm.changeEditorField(flag, operation, selectedItems);
      };

        vm.changeEditorField = function (flag, operation, selectedItems) {
            vm.model.recordChange = true;
            vm.temp = vm.model.selectedSchedule.crewIDsList;

          if (flag === 'isDistributeStandbyConsideringFlights') {
            if (!vm.model.selectedSchedule.isDistributeStandbyConsideringFlights) {
              vm.model.selectedSchedule.selectedStandbyStrategy = null;
            } else {
              vm.model.selectedSchedule.selectedStandbyStrategy = null;
              vm.loadStrategies();
            }
          }

          if (flag === 'isDistStandby') {
            if (!vm.model.selectedSchedule.isDistStandby) {
              vm.model.selectedSchedule.selectedStandbyStrategy = null;
            } else {
              vm.model.selectedSchedule.selectedStandbyStrategy = null;
              vm.loadStrategies();
            }
          }

          if(flag === 'cycle'){
                vm.model.selectedSchedule.fromDate = vm.model.selectedSchedule.cycle.dateFrom!= null
                	?vm.model.selectedSchedule.cycle.dateFrom:null;
                vm.model.selectedSchedule.toDate = vm.model.selectedSchedule.cycle.dateTo!= null
                	?vm.model.selectedSchedule.cycle.dateTo :null;
              vm.model.masterList.patternNames = [];
              vm.refreshPatternNameList();
            }

            if (flag==='fromDate' && !CommonLogicService.compareDateTime(formModel.fromDate, null,formModel.toDate, null)){
                vm.model.selectedSchedule.toDate = formModel.fromDate===""?null:formModel.fromDate;
            }
            if (flag==='toDate' && !CommonLogicService.compareDateTime(formModel.fromDate, null,formModel.toDate, null)){
                vm.model.selectedSchedule.toDate = formModel.fromDate;
            }

          if (flag === 'crewTypeCodesList' && vm.model.selectedSchedule.isSelectCrews) {
            vm.handleCrewTypeChange();
            vm.model.masterList.patternNames = [];
            vm.refreshPatternNameList();
          }

          if (flag === 'isSelectCrews') {
            vm.model.selectedSchedule.crewIDsList = null;
            vm.model.selectedSchedule.patternNames = null;
            // vm.model.masterList.crewList = [];
            // vm.model.masterList.patternNames = [];
          }

          if (flag === 'trainerType') {
            //filter trainer crew list based on trainer type
            var trainerCrews = [];
            if (vm.model.selectedSchedule.trainerType != undefined) {
              angular.forEach(vm.model.masterList.trainerCrews, function (crew) {
                if (crew != undefined && crew.trainerTraineeType === vm.model.selectedSchedule.trainerType.code) {
                  trainerCrews.push(crew.crewProfileId);
                }
              });
              var newCrewList = [];
              angular.forEach(vm.model.masterList.mainCrewList, function (crew) {
                if(trainerCrews.indexOf(crew.crewProfileId) > -1){
                  newCrewList.push(crew);
                }
              });
              vm.model.masterList.crewList = newCrewList;

            } else {
              vm.model.masterList.crewList = vm.model.masterList.mainCrewList;
            }
            vm.model.selectedSchedule.crewIDsList = vm.temp;
          }

          if(flag === 'crewIDsList'){
            vm.temp = vm.model.selectedSchedule.crewIDsList;
          }

          if (flag === 'distributionGroupsList') {
            vm.filterPatternNames(selectedItems);
          }
        };

        vm.filterPatternNames = function (selectedItems) {

          let patternNames = vm.model.masterList.patternNames;
          let filteredPatternNames = [];
          angular.forEach(patternNames, function (pattern) {
            let match = true;
            angular.forEach(selectedItems, function(distGroup) {
              if(pattern.distributionIdentifier.indexOf(distGroup.labelFieldName) === -1) {
                match = false;
              }
            });
            if(match) {
              filteredPatternNames.push(pattern);
            }
          });
          vm.model.masterList.filterPatternNames = filteredPatternNames;

        }

      vm.loadStrategies = function () {
        if (vm.model.masterList.standByStrategiesList.length === 0) {
          AutoRosterScheduleService.getStrategies(
            function (strategies) {
              vm.model.masterList.standByStrategiesList = strategies;
              vm.setDefaultStrategy(strategies);
            },
            function (error) {
              MessageService.error('Failed to load strategies: ' + error);
            }
          );
        } else {
          vm.setDefaultStrategy(vm.model.masterList.standByStrategiesList);
        }
      };

      vm.setDefaultStrategy = function (strategies) {
        var defaultStrategyName;

        if (vm.model.selectedSchedule.isDistributeStandbyConsideringFlights) {
          defaultStrategyName = 'STANDBY_DAY_WISE_DISTRIBUTOR';
        } else if (vm.model.selectedSchedule.isDistStandby) {
          defaultStrategyName = 'STANDBY_DEFAULT';
        }

        if (defaultStrategyName) {
          vm.setSpecificDefaultStrategy(strategies, defaultStrategyName);
        }
      };

      vm.setSpecificDefaultStrategy = function (strategies, defaultStrategyName) {
        if (defaultStrategyName && strategies) {
          var defaultStrategy = strategies.find(function(strategy) {
            return strategy.strategyName === defaultStrategyName;
          });
          if (defaultStrategy) {
            vm.model.selectedSchedule.selectedStandbyStrategy = defaultStrategy;
          }
        }
      };

        vm.submitSchedule = function(action, selectedItem){
            AutoRosterScheduleService.setRosterAutoScheduleSaveReq(selectedItem);
            saveAutoRosterSchedule();
        };

        function moveOnError(data) {
          vm.model.masterList.errorMessage = data.errMsg;
        }

        vm.openRightPanel = function(){
            vm.model.selectedSchedule = AutoRosterScheduleService.getRosterAutoScheduleSaveReq();
            vm.model.selectedSchedule.scheduleDate = moment(new Date()).format(applicationConstants.SETTINGS.DATE_FORMAT);
            vm.model.selectedSchedule.scheduleTime = moment(new Date()).add(5,'m').format(applicationConstants.SETTINGS.TIME_FORMAT);
            vm.model.selectedSchedule.fromDate = vm.model.selectedSchedule.scheduleDate;
            vm.model.selectedSchedule.toDate = vm.model.selectedSchedule.scheduleDate;
            vm.model.showRightPanel = true;
        };

        vm.closeRightPanel = function(){
            if(vm.model.recordChange){
                var confirmClose = {};
                confirmClose.title = "Confirm Close";
                confirmClose.messages = [];
                confirmClose.messages[0] = "Unsaved information will be loss.";
                confirmClose.messages[1] = "Do you want to close this?";
                PopupManager.openModal('CONFIRM_DIALOG', confirmClose, handelConfirmClose);
            }else{
                vm.model.showRightPanel = false;
                vm.model.recordChange = false;
            }
        };

        vm.submitSearch = function (params) {
          if(!vm.model.masterList.fromDateAfterToDate) {
            vm.model.initialSearchDone = true;
            vm.model.searchCriteria = params;
            vm.model.searchCriteria.pageSize = 30;
            vm.model.searchCriteria.startPosition = 1;
            vm.model.autoScheduleList = [];
            searchRosterSchedule();
          }
        };

        function searchRosterSchedule() {
            AutoRosterScheduleService.setRosterSearchCriteria(vm.model.searchCriteria);
            AutoRosterScheduleService.searchAutoRosterSchedule(
                function (AutoRosterSchedules) {
                    if(AutoRosterSchedules.success){
                        updateAutoRosterList(AutoRosterSchedules.autoScheduleResponse);
                        if(vm.model.autoScheduleList.length>0){
                            checkHasCSB();
                        }
                        vm.model.searchPanelToggle = false;
                    }
                    /*if(vm.model.suppliersList.length===0){
                     MessageService.error('No records found');
                     }*/
                    showLoader(false);
                },
                function (error) {
                    MessageService.error(error);
                    showLoader(false);
                }
            );
        }

        function saveAutoRosterSchedule() {
            AutoRosterScheduleService.saveAutoRosterSchedule(
                function (response) {
                    if(response.success){
                        MessageService.success('Auto roster schedule saved!.');
                        vm.model.recordChange = false;
                        vm.model.showRightPanel = false;
                    }else{
                        var ignoreOverlap = {};
                        if(response.warnings.length > 0 && response.warnings[0].indexOf('OVERLAP')>-1){
                            ignoreOverlap.title = "Confirm Overlap";
                            ignoreOverlap.messages = [];
                            ignoreOverlap.messages[0] = response.messages[0];
                            ignoreOverlap.messages[1] = "Do you want to ignore overlap?";
                            PopupManager.openModal('CONFIRM_DIALOG', ignoreOverlap, handelConfirmOverlap);
                        }else if(response.warnings.length > 0 && response.warnings[0].indexOf('INVALID PERIOD')>-1){
                            ignoreOverlap.title = "Confirm Invalid Period";
                            ignoreOverlap.messages = [];
                            ignoreOverlap.messages[0] = response.messages[0];
                            ignoreOverlap.messages[1] = "Do you want to ignore invalid period?";
                            PopupManager.openModal('CONFIRM_DIALOG', ignoreOverlap, handelConfirmOverlap);
                        }else if(response.errors.length>0){
                            MessageService.error(response.errors[0]);
                        }
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function deleteAutoRosterDistribution(autoScheduleSetupId) {
            AutoRosterScheduleService.deleteAutoRosterDistribution(autoScheduleSetupId,
                function (response) {
                    if(response.success){
                        MessageService.success('Roster Distribution Deletion Scheduled!.');
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function handelConfirmClose(pass) {
            if(pass==="YES"){
                vm.model.showRightPanel = false;
                vm.model.recordChange = false;
            }
        }


        function handelConfirmOverlap(pass) {
            if(pass==="YES"){
                AutoRosterScheduleService.setUseIgnoreOverlap();
                saveAutoRosterSchedule();
            }
        }

        function setDefaults(){
            vm.model.searchCriteria = AutoRosterScheduleService.getRosterAutoScheduleSearchCriteria();
        }

        function updateAutoRosterList(autoScheduleResponse) {
            angular.forEach(autoScheduleResponse, function (schedule) {
                vm.model.autoScheduleList.push(schedule);
            });
            vm.model.isElasticLoadingVisible= false;
            angular.element('.elasticLoadingOverlay').addClass('ng-hide');
            angular.element('.fixed_header_table_inner_div').css('overflow', 'auto');
        }

        function checkHasCSB() {
            AutoRosterScheduleService.setCheckCsbSearchCriteria(vm.model.autoScheduleList);
            AutoRosterScheduleService.searchAutoRosterScheduleCheckCSB(
                function (AutoRosterScheduleHasCSBResponse) {
                    if(AutoRosterScheduleHasCSBResponse.success){
                        updateAutoScheduleList(AutoRosterScheduleHasCSBResponse.map);
                    }
                    showLoader(false);
                },
                function (error) {
                    MessageService.error(error);
                    showLoader(false);
                }
            );
        }

        function updateAutoScheduleList(map) {
            angular.forEach(vm.model.autoScheduleList, function (schedule) {
                schedule.hasCrewScheduleBlock = map[schedule.autoScheduleSetupId] ? 'Y' : 'N';
            });
        }

        function updateAutoRosterStatus(autoSchedule) {
            var changeItem = _.find(vm.model.autoScheduleList, {autoScheduleSetupId : autoSchedule.autoScheduleSetupId});
            changeItem.status = autoSchedule.newStatus;
        }

        function getNextSetOfRecords() {
            vm.model.searchCriteria.startPosition = vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize;
            vm.model.isElasticLoadingVisible = true;
            if (angular.element('.elasticLoadingOverlay').length == 0) {
            	var overlay = angular.element('<div class="elasticLoadingOverlay"></div>');
            	overlay.css({
            	    'background-color': '#eee',
            	    'opacity': '0.8',
            	    'position': 'absolute',
            	    'left': '0px',
            	    'top': '0px',
            	    'z-index': '1100',
            	    'height': '100%',
            	    'width': '100%',
            	    'overflow': 'hidden',
            	    'background-image': "url('ajax-loader.gif')",
            	    'background-position': 'center',
            	    'background-repeat': 'no-repeat',
            	    });
            	angular.element(document.body).append(overlay);
        	} else {
        	    angular.element('.elasticLoadingOverlay').removeClass('ng-hide');
        	}
            angular.element('.fixed_header_table_inner_div').css('overflow', 'hidden');
            showLoader(true);
            searchRosterSchedule();
        }

        function showLoader(flag) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                flag: flag,
                target: 'autoRosterSchedule',
                animationName: 'crewing-loader'
            });
        }

      vm.handleCrewTypeChange = function(){
        if (vm.model.selectedSchedule && vm.model.selectedSchedule.isSelectCrews && vm.model.selectedSchedule.crewTypeCodesList) {
          vm.model.masterList.crewList = [];
          if(vm.model.selectedSchedule.cycle == null){
            MessageService.error('Please select cycle');
            return;
          }
          vm.loadCrewListByType(vm.model.selectedSchedule.crewTypeCodesList.crewTypeCode, vm.model.selectedSchedule.cycle.cycleId);
          vm.loadTrainerTraineeList(vm.model.selectedSchedule.crewTypeCodesList.crewTypeCode);
        }
      }

      vm.refreshPatternNameList = function(){
        if (vm.model.selectedSchedule.cycle && vm.model.selectedSchedule.crewTypeCodesList) {
          vm.loadPatternNameList(vm.model.selectedSchedule.cycle.cycleId, vm.model.selectedSchedule.crewTypeCodesList.crewTypeCode);
        } else {
          if(!vm.model.selectedSchedule.cycle) MessageService.error('Please select cycle');
          if(!vm.model.selectedSchedule.crewTypeCodesList) MessageService.error('Please select crew type');
        }
      }

      vm.loadPatternNameList = function(cycleId, crewType) {
        if (!!cycleId && !!crewType) {
          var obj={};
          obj.cycleId = cycleId;
          obj.crewType= crewType;
          CommonMasterData.getRosterPairingNames(obj, function(pairingList){
            vm.model.masterList.patternNames = [];
            angular.forEach(pairingList, function(p) {
              vm.model.masterList.patternNames.push({"patternName" : p.patternName, "distributionIdentifier" : p.distributionIdentifier});
            });
            vm.model.masterList.filterPatternNames = vm.model.masterList.patternNames;
          },function(error){
            console.log("Error in getting pairing names");
          });
        } else {
          vm.model.masterList.patternNames = [];
        }
      }

      vm.loadTrainerTraineeList = function (crewType) {
        AutoRosterScheduleService.getTrainerTraineeList(crewType, function (response) {
          vm.model.masterList.trainerTraineeTypes = response.trainerTraineeTypes;
          vm.model.masterList.trainerCrews = response.trainerCrews;
        }, function (error) {
          MessageService.error(error);
        });

      }

      vm.loadCrewListByType = function(crewType, cycleId){
        var param={};
        param.crewType = crewType;
        param.cycleId = cycleId;
        CommonMasterData.loadRosterCrewList(param,
          function (response) {
            vm.model.masterList.crewList = vm.adaptCrewList(response);
            vm.model.masterList.mainCrewList =  vm.model.masterList.crewList;
            // EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.CREW_LIST_UPDATED);
          },
          function () {
            console.log('Crew list retrieval error');
          }
        );
      };

        vm.adaptCrewList = function (crewList) {
          angular.forEach(crewList, function (crew) {
            crew.displayName = crew.firstName + ' ' + crew.lastName + ' (' + crew.crewId + ')';
          });
          return crewList;
        };


        (function () {
          CommonMasterData.getCrewTypeList(function (response) {
            vm.model.masterList.crewTypes = response;
          }, function (error) {
          });
          CommonMasterData.getCrewBaseList(function (response) {
            vm.model.masterList.crewBaseList = response;
            AutoRosterScheduleService.setDefaultCrewBase(vm.model.masterList.crewBaseList, applicationConstants.SETTINGS.CREW_BASE_AIRPORT);
            vm.model.masterList.statsList = AutoRosterScheduleService.getScheduleStatusMap();
            setDefaults();
          }, function (error) {
          });
          CommonMasterData.getAircraftModels(function (response) {
            vm.model.masterList.airCraftTypes = response;
          }, function (error) {
          });
          AutoRosterScheduleService.getRosterCycles(function (response) {
            vm.model.masterList.cycleList = response;
          }, function (error) {
          });
        })();

      };
}());
